import { useRef } from 'react';
import { ExposedMethods } from '@aleph/shared-components';

// Require the generic type T to have an `id` property of any type
export type HandleUpdateRow<T extends { id: string | number }> = (
	params: {
		row: T;
		isCreate?: boolean;
		isDelete?: boolean;
	}
) => void;

export default function useUpdateRows<T extends { id: string | number }>() {
	const exposedMethods = useRef<ExposedMethods<T> | null>(null);

	const handleUpdateRow: HandleUpdateRow<T> = ({ row, isCreate, isDelete }) => {
		if (exposedMethods.current) {
			exposedMethods.current.updateRows((currentRows) => {
				if (isDelete) {
					// Filter out the row by matching the id
					return currentRows.filter((currRow) => currRow.id !== row.id);
				}

				if (isCreate) {
					return [row, ...currentRows];
				}

				return currentRows.map((currRow) => {
					if (currRow.id === row.id) {
						return {
							...currRow,
							...row,
						};
					}

					return currRow;
				});
			});
		}
	};

	return {
		exposedMethods,
		handleUpdateRow,
	};
}
